/*! Oruga v0.10.4 | MIT License | github.com/oruga-ui/oruga */
import "vue";
import { u as useEventListener } from "./useEventListener-Bx_q-JoG.mjs";
import { u as unrefElement } from "./unrefElement-6_1FNSAa.mjs";
function useClickOutside(elements, handler, options) {
  if (!window) return () => {
  };
  const listenerOptions = Object.assign({ ignore: [] }, options);
  const ignores = Array.isArray(elements) ? elements : [elements];
  const shouldIgnore = (event) => {
    return ignores.some((target) => {
      if (typeof target === "string") {
        return Array.from(
          window.document.querySelectorAll(target)
        ).some(
          (el) => el === event.target || event.composedPath().includes(el)
        );
      } else {
        const el = unrefElement(target);
        return el && (event.target === el || event.composedPath().includes(el));
      }
    });
  };
  function listener(event) {
    if (shouldIgnore(event)) return;
    handler(event);
  }
  const stop = useEventListener(window, "click", listener, listenerOptions);
  return stop;
}
export {
  useClickOutside as u
};
//# sourceMappingURL=useClickOutside-QDIlipII.mjs.map
